import React, { useContext } from "react";
import FormType from "../../../../../shared/components/FormType";
import { basicFields } from "../../../../../configs/customer";
import { Customer } from "../../../../../data/entities";
import { PageContentWrapper } from "../../../../../shared/styled/PageContentStyle";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../../data/enums";

interface ContactPersonProps {
    validated: boolean;
    customerData: Customer;
    handleChangePersonContact: Function;
}

const ContactPersonForm = ({
    validated,
    customerData,
    handleChangePersonContact,
}: ContactPersonProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [ROLE.MANAGER, ROLE.SALE_STAFF].includes(role);

    // Format the customer data to handle multiSelect fields
    const formattedCustomerData = {
        ...customerData,
        // If category is an array, join it, otherwise use as is
        category: Array.isArray(customerData.category) 
            ? customerData.category.join(';')
            : customerData.category
    };

    const getFields = () => {
        return canEdit
            ? basicFields
            : basicFields.map((item) => ({ ...item, disabled: true }));
    };

    return (
        <PageContentWrapper>
            <FormType
                title={"Thông tin khách hàng"}
                requireData={formattedCustomerData}
                mergeFormData={handleChangePersonContact}
                fields={getFields()}
                validated={validated}
            />
        </PageContentWrapper>
    );
};

export default ContactPersonForm;
